const AccessDenied = () => {
  return (
    <div
      className="access-denied"
      style={{
        textAlign: "center",
        marginTop: "50px",
        backgroundColor: "white",
        maxWidth: "500px",
        width: "fit-content",
        margin: "50px auto",
        padding: "30px 50px",
        borderRadius: "5px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
    >
      <h1>Access Denied</h1>
      <p>You do not have permission to view this page.</p>
    </div>
  );
};

export default AccessDenied;
